import { render, staticRenderFns } from "./VenueQrCode.vue?vue&type=template&id=28b510ce&scoped=true"
import script from "./VenueQrCode.vue?vue&type=script&lang=js"
export * from "./VenueQrCode.vue?vue&type=script&lang=js"
import style0 from "./VenueQrCode.vue?vue&type=style&index=0&id=28b510ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Vue/course_selecttion_v3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b510ce",
  null
  
)

export default component.exports